import { useEffect, useMemo } from 'react';

import { hasFeatureAddOnAccess, normalizeFeatureAddOnKey } from '@/shared/entitlements';
import { useBillingStore } from '@/stores/database/aliases/billing';

export function useMissingFeatureAddOnsRequired(requiredKeys?: string[]) {
    const { snapshot, refreshSnapshot } = useBillingStore();

    useEffect(() => {
        if (!snapshot) {
            refreshSnapshot();
        }
    }, [refreshSnapshot, snapshot]);

    return useMemo(() => {
        if (!requiredKeys?.length) {
            return false;
        }

        return requiredKeys.some((requiredKey) => {
            const featureAddOn = normalizeFeatureAddOnKey(requiredKey);

            return !featureAddOn || !hasFeatureAddOnAccess(snapshot, featureAddOn);
        });
    }, [requiredKeys, snapshot]);
}
